import React from 'react';
import Translation from '../translation/translation';

function CrossSellRemoveLightBoxHeader({ data }) {
    const isTyreSizeProtect = (data && data.productType === "tyre_size_protect");
    
    return (
      <div className="cross-sell-remove-light-box__header cross-sell-remove-light-box-header">
        <Translation
          translationKey={
            isTyreSizeProtect ? 'cross-sell-remove-light-box-header-tyre-size' : 'cross-sell-remove-light-box-header'
          }
          className="cross-sell-remove-light-box-header__headline"
        />
      </div>
    );
}

export { CrossSellRemoveLightBoxHeader };
